import { detectEnvironment, isLocalTestAgraphEnabled } from '@blk/aw-env-detection';
import { devConfig } from './envConfigs/dev.config';
import { localConfig } from './envConfigs/local.config';
import { prodConfig } from './envConfigs/prod.config';
import { tstConfig } from './envConfigs/tst.config';
import { uatConfig } from './envConfigs/uat.config';
import { EnvironmentType, PkceEnvironmentConfig } from './types';

/**
 * Environment configuration map
 * Maps environment types to their respective PKCE configurations
 */
const ENVIRONMENT_CONFIG_MAP: Record<EnvironmentType, PkceEnvironmentConfig> = {
  local: localConfig,
  dev: devConfig,
  tst: tstConfig,
  uat: uatConfig,
  prod: prodConfig,
};

/**
 * Get PKCE configuration for the current environment
 *
 * @param env - Optional environment type. If not provided, will auto-detect from hostname
 * @returns The PKCE configuration for the specified/detected environment, or undefined if:
 *          - Environment cannot be detected from hostname
 *          - Environment is 'local' and 'testExternalAgraph' localStorage flag is not set to 'true'
 *          - No configuration exists for the environment
 *
 * Note: Returns undefined gracefully instead of throwing to ensure app continues
 *       to function with relative API endpoints when environment is unknown
 */
export const getPkceConfig = (env?: EnvironmentType): PkceEnvironmentConfig | undefined => {
  const environment = env ?? detectEnvironment();
  const config =
    environment && (environment !== 'local' || isLocalTestAgraphEnabled())
      ? ENVIRONMENT_CONFIG_MAP[environment]
      : undefined;

  return config;
};
